import styled from 'styled-components';
import { theme } from '../../styles/theme.js';
import Flex from '../../Flex.js';
const ModalBody = styled(Flex)`
  padding: ${theme.size.huge};
`;
export { ModalBody };
//# sourceMappingURL=ModalBody.js.map
